module.exports = __webpack_public_path__ + "img/index-3-pic02@2x.337e9bd8.png";